import React from 'react';

export default class DomoReportTest extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className='contentwrapper'>
        <div className='contentheader'>
          <iframe
            title='Domo Report Test'
            src='https://embed.domo.com/embed/pages/1W64V'
            width='100%'
            height='1620'
            marginheight='0'
            marginwidth='0'
            frameborder='0'
          />
        </div>
      </div>
    );
  }
}
